import {Model} from "./model";
import {Box} from "./box";

export class BoxInterface extends Model {

  name?: string;

  description?: string;

  boxes?: Box[];

}

export interface SutBoxInterface {
    qualifiedName: string,
    name: string
}

export interface OnSutBoxInterface {
    qualifiedName: string,
    ifName: string
}
